import workspacesRoutingKeys from "Areas/WorkSpaces/routingKeys";
import { routesAndPagesMap } from "Common/routingUtils";
import { connect } from "react-redux";
import actionCreators from "../redux/actionCreators";
import { getDraft, getHasChanges, getWorkSpaceId } from "../redux/selectors";
import WorkSpaceEditor from "./workSpaceEditor";
const mapStateToProps = (state) => ({
    draft: getDraft(state),
    workSpaceId: getWorkSpaceId(state),
    hasChanges: getHasChanges(state)
});
const mapDispatchToProps = (dispatch, ownProps) => ({
    onSaveWorkSpace: (workSpace) => {
        ownProps.onEditingInProgress && ownProps.onEditingInProgress(true, workSpace.Id);
        Promise.resolve(dispatch(actionCreators.saveWorkSpace(workSpace))).then((promiseResult) => {
            var _a;
            ownProps.onEditingInProgress && ownProps.onEditingInProgress(false, workSpace.Id);
            if (((_a = promiseResult === null || promiseResult === void 0 ? void 0 : promiseResult.response) === null || _a === void 0 ? void 0 : _a.Id) === undefined)
                return;
            ownProps.onHide && ownProps.onHide(workSpace.Id);
            const href = routesAndPagesMap.getPath(workspacesRoutingKeys.WORK_SPACE, promiseResult.response.Id);
            if (href && href !== window.location.href)
                window.location.href = href;
        });
    },
    onSetDraft: (draft) => {
        dispatch(actionCreators.setDraft(draft));
    }
});
export default connect(mapStateToProps, mapDispatchToProps)(WorkSpaceEditor);
